import { render, staticRenderFns } from "./StatusTabHistory.vue?vue&type=template&id=3fb4f3be&scoped=true&"
import script from "./StatusTabHistory.vue?vue&type=script&lang=ts&"
export * from "./StatusTabHistory.vue?vue&type=script&lang=ts&"
import style0 from "./StatusTabHistory.vue?vue&type=style&index=0&id=3fb4f3be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb4f3be",
  null
  
)

export default component.exports